module.exports = "https://cdn.hellotech.com/client-assets/garage_doors_mobile_6fdf4bd23bb8bee9a280c9d97c4912d1.webp";